<ng-container *ngVar="mainQuery.selectLoading() | async as loading">
  @if (loading) {
    <div
      class="fixed inset-0 z-50 flex h-screen w-full flex-col items-center justify-center overflow-hidden opacity-75"
    >
      <div class="spinner mb-4"></div>
      <h2 class="text-center text-xl font-semibold">Loading...</h2>
      <p class="w-1/3 text-center">This may take a few seconds</p>
    </div>
  }
  @if (error && !loading) {
    <div
      class="fixed inset-0 z-50 flex h-screen w-full flex-col items-center justify-center overflow-hidden opacity-75"
    >
      <h2 class="text-center text-xl font-semibold">There is no trial connected to this user.</h2>
      <button class="btn btn--white mt-4 w-32" (click)="logout()">Logout</button>
    </div>
  }
  @if (!error && !loading) {
    <div class="flex min-h-screen flex-col" auxSearchShortcut>
      <header class="flex h-20 items-center justify-between bg-aux-blue-dark px-8">
        <div class="w-200 flex items-center justify-between space-x-4">
          <div class="cursor-pointer" (click)="routingHome()">
            <img class="w-40" src="assets/img/logo.png" alt="Auxilius Logo" />
          </div>
          <div class="h-[35px] border-l"></div>
          @if (showHomeLink()) {
            <div
              class="cursor-pointer text-xl text-white"
              style="font-size: 1rem"
              (click)="routingHome()"
            >
              Home
            </div>
          }

          @if (showEnvIndicator()) {
            <div class="h-[35px] border-l"></div>
          }
          @if (showEnvIndicator()) {
            <aux-stage-indicator />
          }
        </div>

        <div *ngVar="{ open: false } as obj" class="flex h-full items-center">
          @if (showTaskSection$ | async) {
            @if (isHomePageCurrent()) {
              <aux-trial-tasks class="mr-2 flex h-full" />
            }
          }
          <div class="mx-6 flex items-center space-x-6 text-sm">
            @if (!isHomePageCurrent()) {
              <aux-quick-add-actions />
            }

            <a
              class="flex items-center text-white hover:underline"
              target="_blank"
              rel="noopener noreferrer"
              href="https://auxilius.atlassian.net/servicedesk/customer/portals"
            >
              <span class="flex items-center">
                <aux-icon name="Help" class="mr-2" />
                <span>Help Center</span>
              </span>
            </a>
          </div>
          @if (authQuery.fullName$ | async; as fullName) {
            <button
              #trigger="cdkOverlayOrigin"
              class="flex space-x-2 text-sm text-white focus:outline-none"
              cdkOverlayOrigin
              (click)="obj.open = true"
            >
              <span class="flex items-center">
                <aux-icon name="User" class="mr-[5px]" />
                <span>{{ fullName }}</span>
              </span>

              <ng-template
                #overlay="cdkConnectedOverlay"
                cdkConnectedOverlay
                [cdkConnectedOverlayOrigin]="trigger"
                [cdkConnectedOverlayOpen]="obj.open"
                [cdkConnectedOverlayHasBackdrop]="true"
                [cdkConnectedOverlayBackdropClass]="'ttt'"
                (detach)="obj.open = false"
                (backdropClick)="obj.open = false"
              >
                <div
                  class="w-full overflow-hidden rounded border border-aux-gray-dark bg-white text-sm text-aux-black shadow-lg"
                >
                  <ul
                    class="max-h-60 overflow-auto rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
                  >
                    @if (showProfileSection()) {
                      <li
                        class="relative cursor-pointer select-none py-2 pl-3 pr-16 text-gray-900 hover:bg-aux-gray-light"
                        [routerLink]="[accountLink]"
                      >
                        Account Profile
                      </li>
                    }
                    <li
                      class="relative cursor-pointer select-none py-2 pl-3 pr-16 text-gray-900 hover:bg-aux-gray-light"
                      (click)="logout(true)"
                    >
                      Log out
                    </li>
                  </ul>
                </div>
              </ng-template>
            </button>
          }
        </div>
      </header>
      @if ((showEnvBanner$ | async) === true) {
        <aux-stage-banner />
      }
      @if (timelineBannerStatus() && (lsTimelineBannerStatus$ | async) === true) {
        <aux-timeline-warning-banner [timelineBannerStatus]="timelineBannerStatus()" />
      }
      <div class="flex grow bg-gray-100 font-inter">
        @if ((mainQuery.select('sideBar') | async) === true) {
          <div class="hidden md:flex md:shrink-0">
            <div class="flex w-[241px] flex-col">
              <div class="flex h-0 flex-1 flex-col border-r border-gray-200 bg-white">
                <div class="flex flex-1 flex-col gap-[16px] pb-4 pt-5">
                  @if (trials$) {
                    <div class="shrink-0 px-4">
                      <aux-trial-dropdown
                        [trials$]="trials$"
                        [trialFormControl]="trialFc"
                        [mainPage]="true"
                      />
                    </div>
                  }

                  <hr class="mx-[14px] border-t-[2px] border-aux-gray-light-3" />

                  @if (flags().showSearchBar) {
                    <aux-search-section />
                  }

                  <aux-navigation-menu />
                </div>
              </div>
            </div>
          </div>
        }

        <div class="flex w-0 flex-1 flex-col">
          <div class="pl-1 pt-1 sm:pl-3 sm:pt-3 md:hidden">
            <button
              class="-ml-0.5 -mt-0.5 inline-flex h-12 w-12 items-center justify-center rounded-md text-gray-500 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
            >
              <span class="sr-only">Open sidebar</span>
              <aux-icon name="Menu2" />
            </button>
          </div>
          <main
            *ngVar="mainQuery.select('fullPage') | async as fullPage"
            class="relative z-0 flex-1 bg-white focus:outline-none"
            tabindex="0"
          >
            <div
              [ngClass]="{
                'px-7': fullPage === false,
                'py-6':
                  fullPage === false && !shouldPagePaddingbeAdjusted(currentRoute$.getValue()),
                'pb-6': fullPage === false && shouldPagePaddingbeAdjusted(currentRoute$.getValue()),
              }"
            >
              @if ((mainQuery.select('isTrialLoading') | async) === false) {
                <router-outlet />
              }
            </div>
          </main>
        </div>
      </div>
      <div class="flex items-center justify-end bg-aux-gray-light py-2 pr-4 text-aux-gray-dark-100">
        @if (showRoadmapLink()) {
          <span data-pendo-id="roadmap-link" class="btn--hyperlink cursor-pointer">Roadmap</span>
          <span class="mx-2">|</span>
        }
        App Version {{ appInitService.APP_VERSION }}
      </div>
    </div>
  }
</ng-container>
